import * as PIXI from 'pixi.js';
import Element from '../../Prototype/UI/Element';
import UIComponent from './UIComponent';

const RGB2HEX = (r: number, g: number, b: number): number => {
    return (r << 16) + (g << 8) + b;
};

export default class UIRectComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Rect;

    public attach(gameObject: Element, params: any): void {
        const color: Array<number> = params.data.color;
        this.UIComponent = new PIXI.ui.component.Rect(
            RGB2HEX(color[0], color[1], color[2]),
            color[3] / 255
        );

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }

    get color(): number {
        return this.UIComponent.sprite.tint;
    }

    set color(value: number) {
        this.UIComponent.sprite.tint = value;
    }
}
